import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TagFilterComponent } from './tag-filter.component';
import { MaterialsModule } from '../../modules/material.module';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TagModule } from '../tag/tag.module';
import { SearchModule } from '../search/search.module';

@NgModule({
  declarations: [TagFilterComponent],
  imports: [
    CommonModule,
    FormsModule,
    MaterialsModule,
    TagModule,
    ScrollingModule,
    SearchModule,
    MatProgressSpinnerModule,
    TranslateModule.forChild(),
  ],
  exports: [TagFilterComponent],
})
export class TagFilterModule {}
